const cacheName = 'Service Worker Log'
export async function swLog(...args: any[]) {
  const cache = await caches.open(cacheName)

  const jsonResponse = new Response(JSON.stringify(args), {
    headers: {
      'content-type': 'application/json',
    },
  })

  cache.put(new Date().toString(), jsonResponse)
}

export function addSWLogGetterToWindow() {
  //  @ts-ignore
  window.getSwCacheKeys = async () => {
    const cache = await caches.open(cacheName)
    return cache.keys()
  }
  //  @ts-ignore
  window.getCache = async (key: string) => {
    const cache = await caches.match(key)
    return cache?.json()
  }
}
